import initialCacheDataDev from "./__dev__/initialCacheData";

const initialCacheData = {
  currentPageTitle: null,
};

export default process.env.NODE_ENV === "development"
  ? { ...initialCacheData, ...initialCacheDataDev }
  : initialCacheData;
